module.exports = __webpack_public_path__ + "img/IMG_9934-43_FoamcoreMatted.3c70cf22.jpg";